import {
  Box,
  // List,
  // ListItem,
  // ListItemIcon,
  // ListItemText,
  Typography
} from '@mui/material'

import { LoadingScreen } from './LoadingScreen'
import { useContent } from '../../logic'
// import { GestureOutlined, ModeEditOutlineOutlined, ThumbUpAltOutlined } from '@mui/icons-material'

export function LoadingSignatureIframe() {

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100% '}}>
      <Box>
        <Box sx={{ ml: -3, mr: -3 }}>
          <LoadingScreen />
        </Box>
        <Typography variant='h6' sx={{ mt: 3, mb: 2 }} >Your document is being prepared for e-signing...</Typography>
      </Box>
    </Box>
  )
}


// Signing dialog closed by user. Show this when polling to see if they completed their signing
export function LoadingSigningStatuses() {
  const { TaskText } = useContent()

  return (
    <>
      <Box sx={{}}>
        <LoadingScreen />
      </Box>
      <Typography variant='h6' sx={{ mt: 3, mb: 2 }} >We are checking the status of your {TaskText}...</Typography>
    </>
  )
}
